import { render, staticRenderFns } from "./ZoneAlarm.vue?vue&type=template&id=35dff938&"
import script from "./ZoneAlarm.vue?vue&type=script&lang=js&"
export * from "./ZoneAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports